import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown, faCaretUp, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { defineAsyncComponent, nextTick } from "vue";
import { computed } from "vue";
import { useKeyedObjects } from "@/composables/keyedObjects";
import localize from "@/utils/localization";
import FormCard from "./FormCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormRepeat',
    props: {
        input: {
            type: Object,
            required: true,
        },
        sustainRepeats: {
            type: Boolean,
            default: false,
        },
        passthroughProps: {
            type: Object,
            required: true,
        },
        prefix: {
            type: String,
            default: null,
        },
    },
    emits: ["insert", "delete", "swap"],
    setup(__props, { emit }) {
        const props = __props;
        const FormNode = defineAsyncComponent(() => import("./FormInputs.vue"));
        const maxRepeats = computed(() => {
            return typeof props.input.max === "number" ? props.input.cache?.length >= props.input.max : false;
        });
        const minRepeats = computed(() => {
            return typeof props.input.min === "number" ? props.input.cache?.length > props.input.min : true;
        });
        const buttonTooltip = computed(() => {
            return maxRepeats.value
                ? localize(`Maximum number of ${props.input.title || "Repeat"} fields reached`)
                : localize(`Click to add ${props.input.title || "Repeat"} fields`);
        });
        const deleteTooltip = computed(() => {
            return !minRepeats.value
                ? localize(`Minimum number of ${props.input.title || "Repeat"} fields reached`)
                : localize(`Click to delete ${props.input.title || "Repeat"} fields`);
        });
        // @ts-ignore: bad library types
        library.add(faPlus, faTrashAlt, faCaretUp, faCaretDown);
        function onInsert() {
            emit("insert");
        }
        function onDelete(index) {
            emit("delete", index);
        }
        function getPrefix(index) {
            const name = `${props.input.name}_${index}`;
            if (props.prefix) {
                return `${props.prefix}|${name}`;
            }
            else {
                return name;
            }
        }
        function getTitle(index) {
            return `${index + 1}: ${props.input.title}`;
        }
        /** swap blocks if possible */
        async function swap(index, swapWith, direction) {
            if (swapWith >= 0 && swapWith < props.input.cache?.length) {
                emit("swap", index, swapWith);
                await nextTick();
                const buttonId = getButtonId(swapWith, direction);
                document.getElementById(buttonId)?.focus();
            }
        }
        /** get a uid for the up/down button */
        function getButtonId(index, direction) {
            const prefix = getPrefix(index);
            return `${prefix}_${direction}`;
        }
        const { keyObject } = useKeyedObjects();
        return { __sfc: true, FormNode, maxRepeats, minRepeats, buttonTooltip, deleteTooltip, props, emit, onInsert, onDelete, getPrefix, getTitle, swap, getButtonId, keyObject, FontAwesomeIcon, FormCard };
    }
});
